<template>
	<div class="">
		<div class="subj_content">
			<!-- 影视传媒 GO-->
			<div class="pro-container " v-if="jx_index==22">
				<div class="info_tit">
					<div class="tit_left">
						<span>影视作品 </span>
						<el-divider direction="vertical"></el-divider>
						<span>MEDIA</span>
					</div>
					<div class="tit_right f14" @click="go_list(83)">
						<span>查看更多</span>
						<el-divider direction="vertical"></el-divider>
						<span>MORE</span>
					</div>
				</div>
				<div class="row" v-if="arcMediaList.length>0">
					<div class="item   wow fadeInUp animated" v-for="(item,index) in arcMediaList"
						@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink) ">
						<div class="photos video-photo">
							<img class="photo" :src="item.image" />
						</div>
						<div class="info">
							<div class="title line-2">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
							<div class="time">{{lang=='CN' ?item.cn_digest:item.en_digest}}</div>
						</div>
					</div>
				</div>
				<div class="row" v-else>
					暂无数据~
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
	components: {Header,Footer,},
	name: 'coreplate',
	data() {
		return {}
	},
	
}
</script>

<style lang="scss" scoped>
.subj_content {margin: 20px 0;
}
</style>
